import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-12 p-8 sm:gap-16" }
const _hoisted_2 = { class: "flex justify-end" }

import { Ref, ref } from 'vue';
import { Composer, useI18n } from 'vue-i18n';
import { useLocationStore } from '@/stores/location';
import { usePreferencesStore } from '@/stores/preferences';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppLink from '@/components/Base/AppLink.vue';
import AppLogo from '@/components/Base/AppLogo.vue';
import FieldLanguageSelect from '@/components/Fields/FieldLanguageSelect.vue';
import LegalDescription from '@/components/Legal/LegalDescription.vue';
import LegalSection from '@/components/Legal/LegalSection.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegalView',
  setup(__props) {

const translate = useInject(TranslateKey);
const preferencesStore = usePreferencesStore();
const locationStore = useLocationStore();
const i18n: Composer = useI18n();

const language: Ref<string> = ref(preferencesStore.language);

const updateLanguageInStore = (): void => {
  preferencesStore.setLanguage(i18n, language.value);
  locationStore.reloadLayout();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FieldLanguageSelect, {
        modelValue: language.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
          updateLanguageInStore
        ]
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(AppLogo),
    _createVNode(LegalSection, {
      title: _unref(translate)('legal.legalTitle')
    }, {
      default: _withCtx(() => [
        _createVNode(LegalDescription, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)('legal.legalDescription')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(LegalSection, {
      title: _unref(translate)('legal.assetsTitle')
    }, {
      default: _withCtx(() => [
        _createVNode(LegalDescription, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)('legal.assetsIcon')) + " ", 1),
            _createVNode(AppLink, { url: "https://www.reddit.com/r/blackdesertonline" }),
            _createTextVNode(". ")
          ]),
          _: 1
        }),
        _createVNode(LegalDescription, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)('legal.assetsLogo')) + " ", 1),
            _createVNode(AppLink, { url: "https://from_izumi.artstation.com/projects/kggb2" }),
            _createTextVNode(". ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})